import React, { useState, useEffect } from "react";
import StudentLogin from "./components/StudentLogin";

// Grade 7 Quizzes
import MathsQuiz from "./components/quizzes/MathsQuiz";
import EnglishQuiz from "./components/quizzes/EnglishQuiz";
import NaturalScienceQuiz from "./components/quizzes/NaturalScienceQuiz";
import ComputerSkillsQuiz from "./components/quizzes/ComputerSkillsQuiz";

// Grade 8 Quizzes
import MathsQuiz8 from "./components/quizzes/MathsQuiz8";
import EnglishQuiz8 from "./components/quizzes/EnglishQuiz8";
import NaturalScienceQuiz8 from "./components/quizzes/NaturalScienceQuiz8";
import ComputerSkillsQuiz8 from "./components/quizzes/ComputerSkillsQuiz8";

const gradeSubjects = {
  7: ["maths", "english", "natural-science", "computer-skills"],
  8: ["maths", "english", "natural-science", "computer-skills"],
};

function App() {
  const [studentInfo, setStudentInfo] = useState(null);
  const [currentSubjectIndex, setCurrentSubjectIndex] = useState(0);
  const [quizCompleted, setQuizCompleted] = useState(false);
  const [showPersonalityPrompt, setShowPersonalityPrompt] = useState(false);

  const handleLogin = (info) => {
    console.log("[App] Student logged in:", info);
    setStudentInfo({
      name: info.name.trim(),
      grade: info.grade,
      email: info.email.trim(),
    });
    setCurrentSubjectIndex(0);
    setQuizCompleted(false);
    setShowPersonalityPrompt(false);
  };

  const handleQuizComplete = () => {
    console.log("[App] Quiz completed for grade:", studentInfo.grade);
    setQuizCompleted(true);
  };

  useEffect(() => {
    if (!quizCompleted) return;

    const subjects = gradeSubjects[studentInfo.grade];
    console.log("[App] Current subject index before increment:", currentSubjectIndex);
    console.log("[App] Subjects for grade:", subjects);

    if (currentSubjectIndex + 1 < subjects.length) {
      const timer = setTimeout(() => {
        setCurrentSubjectIndex((prev) => prev + 1);
        setQuizCompleted(false);
        console.log("[App] Moving to next subject index:", currentSubjectIndex + 1);
      }, 2000);

      return () => clearTimeout(timer);
    } else {
      setShowPersonalityPrompt(true);
      console.log("[App] All quizzes completed. Showing personality prompt.");
    }
  }, [quizCompleted, currentSubjectIndex, studentInfo]);

  const renderQuiz = () => {
    const { grade } = studentInfo;
    const currentSubject = gradeSubjects[grade][currentSubjectIndex];
    console.log("[App] Rendering quiz for grade:", grade, "subject:", currentSubject);

    const quizProps = {
      studentInfo: { ...studentInfo, subject: currentSubject },
      onComplete: handleQuizComplete,
    };

    const quizzes = {
      7: {
        maths: <MathsQuiz {...quizProps} />,
        english: <EnglishQuiz {...quizProps} />,
        "natural-science": <NaturalScienceQuiz {...quizProps} />,
        "computer-skills": <ComputerSkillsQuiz {...quizProps} />,
      },
      8: {
        maths: <MathsQuiz8 {...quizProps} />,
        english: <EnglishQuiz8 {...quizProps} />,
        "natural-science": <NaturalScienceQuiz8 {...quizProps} />,
        "computer-skills": <ComputerSkillsQuiz8 {...quizProps} />,
      },
    };

    return quizzes[grade]?.[currentSubject] || <p>Unknown subject.</p>;
  };

  if (!studentInfo) {
    return <StudentLogin onSubmit={handleLogin} />;
  }

  if (showPersonalityPrompt) {
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        <h2> You’ve completed all your assessments!</h2>
        <p>Click the link and complete the personality test.</p>
        <a
          href="https://www.16personalities.com/free-personality-test"
          target="_blank"
          rel="noreferrer"
          style={{
            display: "inline-block",
            background: "#02A552",
            color: "#fff",
            padding: "12px 20px",
            borderRadius: 8,
            fontSize: 18,
            fontWeight: "600",
            textDecoration: "none",
            marginTop: 20,
          }}
        >
          Take Personality Test
        </a>
      </div>
    );
  }

  if (quizCompleted) {
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        <div className="spinner"></div>
        <p style={{ marginTop: 12, color: "#00154A", fontSize: 16 }}>Loading next quiz...</p>
      </div>
    );
  }

  return <div>{renderQuiz()}</div>;
}

export default App;











